import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../../ApiGenericResponse";

export class GetDashboardSharingTokenResData extends ApiGenericResponse {
    sharingToken: string;

    constructor(response: AxiosResponse) {
        super(response);
        if (response.data && response.data.Payload && response.data.Payload.SharingToken) this.sharingToken = response.data.Payload.SharingToken;
    }
}
